export function Section({ id, eyebrow, title, sub, children }) {
  return (
    <section id={id} className="scroll-mt-32 mb-14" data-testid={`partner-section-${id}`}>
      <p className="text-[11px] uppercase tracking-[0.22em] text-primary mb-2">{eyebrow}</p>
      <h2 className="font-serif text-3xl sm:text-4xl leading-tight">{title}</h2>
      {sub && <p className="text-muted-foreground mt-2 max-w-xl">{sub}</p>}
      <div className="mt-6">{children}</div>
    </section>
  );
}

export function Chips({ items, value, onPick, testPrefix }) {
  return (
    <div className="flex flex-wrap gap-2">
      {items.map(([key, label]) => (
        <button key={key} onClick={() => onPick(key)} data-testid={`${testPrefix}-${key}`}
          className={`rounded-full px-4 py-2 text-sm border transition-colors duration-200 ${value === key ? "bg-primary text-primary-foreground border-primary" : "border-border hover:border-primary/50"}`}>
          {label}
        </button>
      ))}
    </div>
  );
}
